import { render } from "./LeadStep2.vue?vue&type=template&id=7841cc8a"
import script from "./LeadStep2.vue?vue&type=script&lang=js"
export * from "./LeadStep2.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__